export default __webpack_public_path__ + "static/media/extend1.9539a527.jpg";